import { render, staticRenderFns } from "./SelectTicketsPricegroups.vue?vue&type=template&id=73a7b881&"
import script from "./SelectTicketsPricegroups.vue?vue&type=script&lang=js&"
export * from "./SelectTicketsPricegroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports